import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Comment, CreateCommentDto, UpdateCommentDto } from '@/core/models/comment.model';

@Injectable({
  providedIn: 'root',
})
export class CommentService {
  private http = inject(HttpClient);
  private oidcSecurityService = inject(OidcSecurityService);
  private apiUrl = `${window.location.origin}/api`; // Adjust if your base API URL is different

  getComments(parentType: string, parentId: number): Observable<Comment[]> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.get<Comment[]>(`${this.apiUrl}/${parentType}/${parentId}/comments`, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  addComment(parentType: string, parentId: number, commentData: CreateCommentDto): Observable<Comment> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.post<Comment>(`${this.apiUrl}/${parentType}/${parentId}/comments`, commentData, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  updateComment(commentId: number, commentData: UpdateCommentDto): Observable<Comment> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.patch<Comment>(`${this.apiUrl}/comments/${commentId}`, commentData, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }

  deleteComment(commentId: number): Observable<void> {
    return this.oidcSecurityService.getIdToken().pipe(
      switchMap((idToken) =>
        this.http.delete<void>(`${this.apiUrl}/comments/${commentId}`, {
          headers: { Authorization: `Bearer ${idToken}` },
        })
      )
    );
  }
}
